/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { atom, createStore } from "jotai/vanilla";

export const SPANGLE_MODES = {
  spangleIt: "spangle-it",
  editSize: "edit-size",
  sizeEdited: "size-edited",
  spanglesLoading: "spangles-loading"
};

const lastSpangledDimensionsDefault = { width: null, height: null };

export const jotaiStore = createStore();

export const lastSpangledDimensionsAtom = atom(lastSpangledDimensionsDefault);

export const spangleVariationsAtom = atom([]);

export const spangleModeAtom = atom(SPANGLE_MODES.spangleIt);

export const selectedAlgorithmAtom = atom(null);

export const originalArtworkUrlAtom = atom("");

export const spanglesMaxImageCountAtom = atom(1);

export const allAPIsCompletedStateAtom = atom(true);

export const invalidSpangleSelectedAtom = atom(false);

export const isSpangleReorderingAtom = atom(false);

export const completedSpangleDataAtom = atom([]);
